import React, { useState, useContext } from 'react';
import style from './RecoverPassword.module.css';

import Lottie from 'lottie-react';
import password_animation from '../../lottieAnimations/forgot_password_animation.json';
import verification_animation from '../../lottieAnimations/email_verification_animation.json';
import icons from '../../icons';
import urls from '../../urls';

import { auth } from '../../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { AppContext } from '../../AppContext';
import Banner from '../Banner/Banner';


const RecoverPassword = props => {
    const { users, setPage } = useContext(AppContext);

    const [sentRequest, setSentRequest] = useState(false);
    const [email, setEmail] = useState("");
    const [error, setError] = useState(undefined);

    if (!sentRequest)
        return <>
            <Banner />
            <main className={ style.main }>
                <div className={ style.error } onClick={ () => setError(undefined) } style={{
                        opacity: error ? "1" : "0",
                        display: error ? "flex" : "none"
                }}>
                    <img alt="" src={ icons.warning_icon }></img>
                    <h4>{ error }</h4>
                </div>
                <h2 className={ style.mainHeader } style={{ color: "var(--orange)" }}>Password dimenticata?</h2>
                <h3 className={ style.subHeader }>Nessun problema, ti invieremo una mail per recuperare il tuo account!</h3>
                <Lottie 
                    style={{ marginTop: "3rem" }}
                    loop={ true }
                    autoplay={ true }
                    animationData={ password_animation }
                    height={ 300 }
                    width={ 300 }
                />
                <div className={ style.emailInput }>
                    <img alt="" src={ icons.email_orange_icon } />
                    <input placeholder="Email" type="email" value={ email } onChange={ event => setEmail(event.target.value) }></input>
                </div>
                <div className={ style.button } onClick={ async () => {
                    if (email === "") {
                        setError("Inserisci un indirizzo email!");
                        return;
                    } 
                    if (!email.match(/^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/)) {
                        setError("Inserisci un indirizzo email valido!");
                        return;
                    }
                    if (!Object.values(users).map(user => user.email).includes(email)) {
                        setError("Nessun account registrato con questo indirizzo email")
                        return;
                    }
                    try {
                        await sendPasswordResetEmail(auth, email, {
                            url: urls.base
                        });
                        setSentRequest(true);
                    } catch (err) {
                        console.warn(err);
                        setError("Inserisci un indirizzo email valido!");
                    }
                } }>
                    <img src={ icons.send_white_icon }></img>
                    <h3>RECUPERA PASSWORD</h3>
                </div>
                <div className={ style.button } style={{ background: "linear-gradient(to right, rgb(89, 0, 255), rgb(81, 0, 187))" }} onClick={ () => setPage({ page: "login" }) }>
                    <img src={ icons.login_icon }></img>
                    <h3>TORNA AL LOGIN</h3>
                </div>
            </main>
        </>;

    return <>
        <Banner />
        <main className={ style.main }>
            <Lottie 
                style={{ marginTop: "3rem" }}
                loop={ true }
                autoplay={ true }
                animationData={ verification_animation }
                height={ 300 }
                width={ 300 }
            />
            <h2 className={ style.mainHeader }>Ti abbiamo inviato una mail per il recupero della tua password all'indirizzo <span style={{ color: "var(--orange)" }}>{ email }</span></h2>
            { email.includes("@gmail.com") && <div onClick={ () => window.open("https://mail.google.com/mail") } className={ style.button }>
                <img src={ icons.email_icon }></img>
                <h3>APRI GMAIL</h3>
            </div> }
        </main>
    </>;
};

export default RecoverPassword;